import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";
import { Bell, Lightning } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const NotificationBell = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch (e) { /* not logged in / ignore */ }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [load]);

  const onOpen = async (open) => {
    if (open && unread > 0) {
      try { await api.post("/notifications/read"); setUnread(0); } catch (e) {}
    }
  };

  return (
    <DropdownMenu onOpenChange={onOpen}>
      <DropdownMenuTrigger data-testid="notification-bell" className="relative flex items-center justify-center w-9 h-9 rounded-md text-zinc-300 hover:text-white hover:bg-white/10 transition-colors">
        <Bell size={20} weight={unread > 0 ? "fill" : "regular"} />
        {unread > 0 && (
          <span data-testid="notification-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#E11D2A] text-white text-[10px] font-bold flex items-center justify-center">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto p-0">
        <div className="px-4 py-2.5 border-b border-zinc-100 text-sm font-semibold">{t("notifications")}</div>
        {items.length === 0 ? (
          <div data-testid="no-notifications" className="px-4 py-6 text-sm text-zinc-400 text-center">{t("no_notifications")}</div>
        ) : (
          items.map((n) => (
            <button key={n.id} data-testid={`notification-${n.id}`} onClick={() => n.job_id && navigate(`/jobs/${n.job_id}`)}
              className={`w-full text-left px-4 py-3 border-b border-zinc-50 hover:bg-zinc-50 transition-colors ${!n.read ? "bg-[#E11D2A]/5" : ""}`}>
              <div className="flex items-start gap-2">
                {n.type?.startsWith("spoed") && <Lightning size={15} weight="fill" className="text-[#E11D2A] mt-0.5 shrink-0" />}
                <div className="min-w-0">
                  <div className="text-sm font-semibold truncate">{n.title}</div>
                  <div className="text-xs text-zinc-500 line-clamp-2">{n.body}</div>
                </div>
              </div>
            </button>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
